<template>
  <div class="outer-wrapper">
    <div class="editor-wrapper" v-show="!orderShow">
      <div class="title-wrapper">
        <span>检测中心项目一栏</span>
      </div>
      <van-search
        v-model="superProjectKeyword"
        placeholder="请输入项目名称关键字"
        input-align="center"
        @search="onSuperProjectSearch"
        />
      <van-list
        v-model="superProjectTable.loading"
        :finished="superProjectTable.finished"
        finished-text="没有更多了"
        :error.sync="superProjectTable.error"
        error-text="请求失败，点击重新加载"
        @load="onSuperProjectLoad"
      >
        <van-cell
          v-for="(item,index) in superProjectTable.tivdata"
          :key="index+'su'"
          :title="item.name"
          @click="chooseSuperProject(item)"
          is-link
        >
          <span class="cell-item">{{'??'}}</span>
          <span class="cell-item">{{'??'}}</span>
        </van-cell>
      </van-list>
    </div>
    <div class="report-wrapper" v-show="orderShow">
      <van-nav-bar
        :title="'项目订单('+currentSuperProject.name+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickBack"
        fixed
      ></van-nav-bar>
      <van-search
        v-model="orderKeyword"
        placeholder="请输入委托单号"
        input-align="center"
        @search="onOrderSearch"
        />
      <van-list
        v-model="orderTable.loading"
        :finished="orderTable.finished"
        finished-text="没有更多了"
        :error.sync="orderTable.error"
        error-text="请求失败，点击重新加载"
        @load="onOrderLoad"
      >
        <van-cell
          v-for="(item,index) in orderTable.tivdata"
          :key="index+'o'"
          :title="'('+projectDisplayNoAbbr(item.project_display_no)+')'"
          @click="chooseOrder(item)"
          is-link
        >
          <span class="cell-item">{{item.create_time.split(" ")[0]}}</span>
          <span class="cell-item">{{item.sample_stat}}</span>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
import { textTrans } from "@/mixins/TextTrans.js";

function superProjectTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [
    ]
  };
}

function orderTableFac() {
  return {
    loading: false,
    finished: false,
    error: false,
    Tpage: {
      currentPage: 1,
      currentSize: 20
    },
    no_data_text: "",
    totalItems: 0,
    tivdata: [
    ]
  };
}

export default {
  name: "superProjectList",
  components: {},
  mixins: [textTrans],
  data() {
    return {
      superProjectTable: superProjectTableFac(),
      orderTable:orderTableFac(),
      orderShow: false,
      currentSuperProject: {},
      superProjectKeyword:'',
      orderKeyword:''
    };
  },
  watch: {},
  computed: {
  },
  created() {},
  methods: {
    onSuperProjectSearch(){
      this.superProjectTable.tivdata = [];
      this.superProjectTable.Tpage.currentPage = 1;
      this.superProjectTable.Tpage.currentSize = 20;
      this.superProjectTable.finished = false;
      this.onLoad();
    },
    onSuperProjectLoad() {
      this.superProjectTable.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.superProjectTable.Tpage,
          userToken: userToken,
          ask_data: "superProjectList",
          selected_list: [],
          keyword: this.superProjectKeyword,
        })
        .then(response => {
          for (let ele of response.data.res_record) {
            this.superProjectTable.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.superProjectTable.Tpage.currentSize
          ) {
            this.superProjectTable.finished = true;
          }
          this.superProjectTable.loading = false;
          this.superProjectTable.Tpage.currentPage++;
        });
    },
    chooseSuperProject(val) {
      this.currentSuperProject = val;
      this.orderShow = true;
    },
    onClickBack() {
      this.orderShow = false;
      this.currentSuperProject = {
        id:0
      };
    },
    chooseOrder(val){
        location.href = val.id;
    },
    onOrderSearch(){
      this.orderTable.tivdata = [];
      this.orderTable.Tpage.currentPage = 1;
      this.orderTable.Tpage.currentSize = 20;
      this.orderTable.finished = false;
      this.onLoad();
    },
    onOrderLoad() {
      this.orderTable.loading = true;
      this.$axios
        .post(this.$url + "/ask_list_data", {
          page: this.orderTable.Tpage,
          userToken: userToken,
          ask_data: "orderPerSuperProjectList",
          selected_list: [],
          orderKeyword: '',
          superProjectId:this.currentSuperProject.id
        })
        .then(response => {
          for (let ele of response.data.res_record) {
            this.orderTable.tivdata.push(ele);
          }
          if (
            response.data.res_record.length < this.orderTable.Tpage.currentSize
          ) {
            this.orderTable.finished = true;
          }
          this.orderTable.loading = false;
          this.orderTable.Tpage.currentPage++;
        });
    },

  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height: 20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color: #999;
  padding: 1rem;
  background: #fff;
  border-bottom: 1px solid #f6f6f6;
}

.editor-wrapper {
  width: 100%;
}
.cell-item {
  margin-left: 0.6rem;
}

.op {
  outline: none;
  border: 1px solid #eee;
  color: #fff;
  background: rgb(11, 155, 18);
  font-weight: 400;
  height: 1rem;
  position: relative;
  top: 0.05rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.2rem;
}
.deny {
  background: rgb(228, 46, 14);
  margin-left: 0.5rem;
}

.text-wrapper {
  padding: 0.1rem 0.5rem;
}
.text-wrapper-con {
  padding: 1rem 0 1rem 2rem;
}

.textarea {
  width: 100%;
  height: 7rem;
}
.bold-text {
  font-weight: 600;
  color: #666;
}
.d-wrapper {
  padding: 0.5rem 1rem;
  text-align: center;
  font-size: 0.6rem;
}
.button-wrapper {
  padding: 2rem;
  text-align: center;
}
.radio-item {
  margin-top: 1rem;
  margin-left: 30%;
}
</style>